import {
  SaveButton,
  Toolbar,
  useRecordContext,
  useResourceContext
} from 'react-admin';
import { DeleteConfirmationButton } from './DeleteConfirmationButton';

export const CustomEditToolbar = ({ alwaysEnable, ...props }) => {
  const record = useRecordContext();
  const resource = useResourceContext();

  return (
    <Toolbar {...props} sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <SaveButton alwaysEnable={alwaysEnable} />
      {record && record.id && (
        <DeleteConfirmationButton resource={resource} selectedIds={[record.id]} />
      )}
    </Toolbar>
  );
};
